import '@zr/common/js/get-auto-banners';
import { fetchReportJobModalHtml } from '@seo/js/common/ajax_hero_request';
import initZDSFooter from '@seo/js/partials/_footer-zds';
import { initializeJobResults } from './components/JobResultsEntry';

const onMarkerClick = (event) => {
  window.location = event.target.options.href;
};

async function lazyLoad(jobsListSelector) {
  import(/* webpackChunkName: "suggestedSearches" */ '@seo/js/suggested-searches');
  import(/* webpackChunkName: "smartApplyTooltip" */ './partials/_smart_apply_tooltip');
  import(/* webpackChunkName: "initApplyFlow" */ '../react/components/ApplyFlow/_apply-flow').then(({ default: initApplyFlow }) => initApplyFlow());
  import(/* webpackChunkName: "initInsights" */ './partials/_jobseeker-insights').then(({ default: initInsights }) => initInsights());
  import('@seo/js/utils/send-mixer-ping');
  await import('@zr/common/css/vendor/leaflet-1.8.0.css');
  await import('@zr/common/js/vendor/leaflet-1.8.0.min');
  import('@seo/css/partials/_modal_estimated_pay.less');
  import('./partials/_save_job').then(({ default: initSaveJob }) => initSaveJob());
  import('./partials/_email-popover').then(({ initEmailPopover }) => initEmailPopover());
  import('./partials/dirp/infinite-scroll').then(({ default: initInfiniteScroll }) => initInfiniteScroll());
  import('./partials/_external_feedback').then(({ default: initExternalFeedback }) => initExternalFeedback(jobsListSelector, '[data-external-job]'));
  import('./partials/_satisfaction_survey').then(({ default: initSatisfactionSurvey }) => initSatisfactionSurvey());

  const { jobList, isWithMap } = window.zr.page.model;
  if (jobList && isWithMap) {
    const group = [];
    const map = window.L.map('map').setView([0, 0], 0);
    window.L.tileLayer('https://api.maptiler.com/maps/outdoor/256/{z}/{x}/{y}.png?key=t9ijxYbDSt4Ca1YnbFHU', {
      attribution:
        '&copy; <a href="https://www.maptiler.com/copyright">maptiler</a> contributors',
    }).addTo(map);

    const myIcon = window.L.icon({
      iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=',
    });

    jobList.forEach((job) => {
      const marker = window.L.marker([job.Lat, job.Lng], { icon: myIcon, href: job.Href }).on('click', onMarkerClick)
        .bindPopup(`<p>${job.Title} - ${job.OrgName}</p>`);
      marker.on('mouseover', (event) => {
        event.target.openPopup();
      });
      marker.addTo(map);
      group.push(marker);
    });

    // eslint-disable-next-line new-cap
    const featureGroup = new window.L.featureGroup(group);
    map.fitBounds(featureGroup.getBounds());
  }

  let reportJobModalHtmlLoaded = $('[data-modal="report-job"]').length > 0;
  $(document).on('click', '[data-type="report-job"]', async (e) => {
    if (!reportJobModalHtmlLoaded) {
      reportJobModalHtmlLoaded = await fetchReportJobModalHtml();
    }
    await import('./partials/_report_job_modal').then(({ default: initReportJobModal }) => {
      initReportJobModal(e);
    });
  });

  $('body').on('click', '[data-type="estimated-pay-info-button"]', () => {
    $('[data-type="estimated-pay-modal"]').modal('show');
    $('.modal-close.zrs_close_btn').html(''); // Hacky fix for jquery.modal close btn text appearing
  });

  // Tracking for jobs. TODO: Are these events still used?
  $(jobsListSelector).on('click', '[data-tracking]', (event) => {
    const $target = $(event.target);

    $.log_event('dirp_job_click', {
      click_area: $target.attr('data-tracking'),
      posted_on: 'ZipRecruiter',
      online: 0,
    });
  });

  // add refu param to job card links
  const jobCardLinks = document.querySelectorAll(`${jobsListSelector} [data-job-list-item] a`);
  jobCardLinks.forEach((link) => {
    const newURL = new URL(link.href);
    newURL.searchParams.append('refu', encodeURIComponent(window.location.pathname + window.location.search));
    link.setAttribute('href', newURL.toString());
  });

  // SEARCH-2824 set cookie so that mobile back button works on job page
  // TODO remove this if/when the job page doesn't rely on this cookie
  document.cookie = 'last_js_u=this value does not matter;';

  // Set modal params.
  if ($.modal) {
    $.modal.wait = 0;
    $.modal.zrsCloseBtn = true;
  }
}

const jobsListSelector = '[data-jobs-list]';
lazyLoad(jobsListSelector);

if (window.zr.page.model.isZDS) {
  initializeJobResults();
}

initZDSFooter();
